import publicPage from './publicpage'
import testPage from './testpage'
import privatePage from './privatepage'
import pdfReport from './pdfReport'

export default {
  publicPage,
  testPage,
  privatePage,
  pdfReport,
  lang: 'Language',
  sv: 'Swedish',
  en: 'English',
  de: 'German',
  it: 'Italian',
  yes: 'Yes',
  no: 'No',
  name: 'Name',
  last_name: 'Last name',
  first_name: 'First name',
  email_pin: 'Email / PIN',
  customer_tag: 'Tag',
  method: 'Method',
  end_date: 'End date',
  change_end_date: 'Change end date',
  finished_date: 'Finished',
  test_not_started: 'Not started',
  test_started: 'Started',
  test_finished: 'Finished',
  report: 'Report',
  create_report: 'Generate profile',
  create_teamprofile: 'Generate team profile',
  create_teamreport: 'Generate team report',
  team_name: 'Team name',
  report_type: 'Report type',
  report_cost: 'Credit cost',
  report_unsupported_testmethod: 'Unsupported test method',
  name_required_feedback: 'Name required!',
  field_required_feedback: 'Required field.',
  participant: 'Participant',
  test: 'Tests',
  available_credits: 'Available credits',
  norm_group: 'Norm group',
  save: 'Save',
  preview: 'Preview',
  save_randomize: 'Save & randomize',
  save_ok_feedback: 'The information has been saved',
  delete: 'Delete',
  reset: 'Reset',
  cancel: 'Cancel',
  update: 'Update',
  logo: 'Logotype',
  questions: 'Questions',
  question: 'Question',
  questionalternative: 'Answer alternatives',
  errorMessage_server: 'An error has occurred',
  example: 'Example',
  pageNotFoundMessage: 'Page not found!',
  folder: 'Folder',
  image: 'Image',
  number: 'Number',
  swedish: 'Swedish',
  english: 'English',
  deutsch: 'Deutsch',
  select_a_language: 'Choose a language',
  select_a_normgroup: 'Choose a norm group',
  select_a_report: 'Choose a report',
  clear: 'Clear filter',
  type_to_search: 'Type to search',
  content: 'Content',
  search: 'Search',
  from: 'From',
  to: 'To',
  amount: 'Amount',
  date: 'Date',
  result: 'Result',
  header: 'Heading',
  description: 'Description',
  text: 'Text',
  expert_report: 'Reports',
  create_expert_report: 'Generate report',
  team_report: 'Team profile',
  prevPage: 'Previous',
  nextPage: 'Next'
}
